import React from "react";
import { Tag } from "antd";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { FormItem, dineroDisabledMask, round2Decimals } from "../../../../Components/Items";

/**
 * Renglón-encabezado de un cliente en la tabla de ventas de VerVentasCliente, cuando se
 * cobran juntas ventas de varios clientes con el mismo RFC y razón social (la
 * `agrupacion` de TabbedDynamicTable). Mismo patrón que EncabezadoFamiliaOC.
 *
 * Como la razón social es la misma en todos los grupos, el del cliente abierto lleva una
 * etiqueta para distinguirlo.
 *
 * Lo cobrado se lee del formulario con `FormItem noStyle shouldUpdate`, para que se
 * refresque al capturar una cantidad sin re-renderizar la tabla completa.
 *
 * @param {Object} grupo         { id, nombre, principal } que devolvió `obtenerGrupo`
 * @param {Array}  arrayKeys     índices reales de las filas de este cliente
 * @param {Array}  ventasCliente las ventas del state (saldo pendiente de cada fila)
 */
const EncabezadoClienteCobro = ({
  grupo,
  arrayKeys,
  colapsado,
  alternar,
  totalColumnas,
  ventasCliente,
}) => {
  const llaves = arrayKeys || [];
  const saldo = round2Decimals(
    llaves.reduce((suma, k) => suma + (ventasCliente?.[k]?.saldoPendiente || 0), 0)
  );

  return (
    <FormItem
      noStyle
      shouldUpdate={(previo, actual) => previo.ventas !== actual.ventas}
    >
      {({ getFieldValue }) => {
        const ventas = getFieldValue("ventas") || [];
        const aCobrar = round2Decimals(
          llaves.reduce((suma, k) => suma + (ventas[k]?.cantidadPagar || 0), 0)
        );

        return (
          <tr
            onClick={alternar}
            style={{ backgroundColor: "#e6f7ff", cursor: "pointer" }}
            title={colapsado ? "Mostrar las ventas de este cliente" : "Ocultar las ventas de este cliente"}
          >
            <td
              className="td-border"
              colSpan={totalColumnas}
              style={{ textAlign: "left", padding: "8px 16px", borderBottom: "1px solid #91d5ff" }}
            >
              <span style={{ color: "#0050b3", marginRight: 8 }}>
                {colapsado ? <RightOutlined /> : <DownOutlined />}
              </span>
              <span
                style={{
                  fontWeight: 800,
                  fontSize: 11,
                  color: "#0050b3",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  marginRight: 8,
                }}
              >
                {grupo.nombre || "Cliente"}
              </span>
              {grupo.principal && <Tag color="blue">Cliente abierto</Tag>}
              <span style={{ fontSize: 11, color: "#0050b3", opacity: 0.75, marginLeft: 4 }}>
                {llaves.length} {llaves.length === 1 ? "venta" : "ventas"}
              </span>
              <span style={{ fontSize: 12, color: "#0050b3", marginLeft: 12 }}>
                Saldo: <b>{dineroDisabledMask(saldo)}</b>
              </span>
              <span style={{ fontSize: 12, color: "#0050b3", marginLeft: 12 }}>
                A cobrar: <b>{dineroDisabledMask(aCobrar)}</b>
              </span>
            </td>
          </tr>
        );
      }}
    </FormItem>
  );
};

export default EncabezadoClienteCobro;
